var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgForm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 3,
  x: 4,
  y: 4,
  fill: "currentColor",
  rx: 1
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 3,
  x: 4,
  y: 10,
  fill: "currentColor",
  rx: 1
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 7,
  height: 3,
  x: 4,
  y: 16,
  fill: "currentColor",
  rx: 1
})));
export default SvgForm;